import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useToast } from '@/components/ui/use-toast';
import { getAccessToken, saveTokens } from '@/lib/googleFit';
import { Card, CardContent } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

export default function CallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const { toast } = useToast();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log('Processing Google callback...');

        const code = searchParams.get('code');
        const error = searchParams.get('error');

        if (error) {
          console.error('Google auth error:', error);
          throw new Error(`Erreur d'authentification Google: ${error}`);
        }

        if (!code) {
          console.error('No authorization code received');
          throw new Error('Code d\'autorisation manquant');
        }

        if (!currentUser) {
          console.error('No authenticated user found');
          throw new Error('Utilisateur non connecté');
        }

        console.log('Exchanging code for tokens...');
        const tokens = await getAccessToken(code);
        
        console.log('Saving tokens...');
        await saveTokens(currentUser.id, tokens);

        console.log('Google Fit connection successful');
        toast({
          title: "Connexion réussie",
          description: "Votre compte Google Fit a été connecté avec succès.",
        });

        navigate('/projector-watch/dashboard');

      } catch (error: any) {
        console.error('Error in Google callback:', error);
        toast({
          variant: "destructive",
          title: "Erreur de connexion",
          description: error.message || "Une erreur est survenue lors de la connexion à Google Fit.",
        });
        navigate('/projector-watch/dashboard');
      }
    };

    handleCallback();
  }, [searchParams, navigate, currentUser, toast]);

  return (
    <div className="min-h-screen pt-20 flex items-center justify-center px-4 bg-gradient-to-br from-blue-50 via-indigo-50 to-blue-100">
      <Card className="w-full max-w-md">
        <CardContent className="p-8 flex flex-col items-center gap-4">
          <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
          <p className="text-center text-gray-600">
            Connexion à Google Fit en cours...
          </p>
        </CardContent>
      </Card>
    </div>
  );
}